module.exports = __webpack_public_path__ + "media/src/images/mypage/slash-f0c383725c80c2073e749337bd4176d1.png";